import { render, staticRenderFns } from "./reAsignaCartera.vue?vue&type=template&id=a233403a"
import script from "./reAsignaCartera.vue?vue&type=script&lang=js"
export * from "./reAsignaCartera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports